var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"widebox",style:({
      background: _vm.background
  })}),_vm._l((6),function(n){return _c('br',{key:n})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }